import axios from 'axios';
import moment from 'moment';
import { getSapAuthToken } from 'utils/getSAPAuthToken';

export default class Bill {
  subscriptionId: any;
  customerId: any;

  monthlyBill: any;

  requestPath: any;
  requestPath1: any;
  requestParams: any;

  constructor(subscriptionId, customerId) {
    this.subscriptionId = subscriptionId;
    this.customerId = customerId;

    this.monthlyBill = {
      amount: 0,
      currencyCode: 'USD',
    };

    this.requestPath = '/BillV2_APIs/bills?customer.id=';
    this.requestPath1 = '&expand=all&billItems.subscription.documentNumber=';
    this.requestParams = '&billStatus=OPEN&sort=billingDate,asc';
  }

  async fecthJWTToken() {
    try {
      const response = await getSapAuthToken().then(response => {
        return response.body?.access_token;
      });
      return response;
    } catch (error) {
      console.log(error);
    }
  }

  async fetchJWTType() {
    try {
      const response = await getSapAuthToken().then(response => {
        return response.body?.token_type;
      });
      return response;
    } catch (error) {
      console.log(error);
    }
  }

  async fetchMonthlyBill() {
    try {
      const token = await this.fecthJWTToken().then(response => {
        return response;
      });
      const type = await this.fetchJWTType().then(response => {
        return response;
      });
      const url = `${process.env.REACT_APP_SAP_SB_PROXY_API_URL}${this.requestPath}${this.customerId}${this.requestPath1}${this.subscriptionId}${this.requestParams}`;
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      const response = await axios
        .get(url, {
          headers: {
            Authorization: `${type} ${token}`,
          },
        })
        .then(response => {
          this.monthlyBill['amount'] =
            response.data[0]['billItems'][0]['netAmount']['amount'];
          this.monthlyBill['currencyCode'] =
            response.data[0]['billItems'][0]['netAmount']['currency'];
        });
      return this.monthlyBill;
    } catch (error) {
      console.log(error);
    }
  }

  async fetchBillingCycleDate() {
    try {
      const token = await this.fecthJWTToken().then(response => {
        return response;
      });
      const type = await this.fetchJWTType().then(response => {
        return response;
      });
      const url = `${process.env.REACT_APP_SAP_SB_PROXY_API_URL}${this.requestPath}${this.customerId}${this.requestPath1}${this.subscriptionId}${this.requestParams}`;
      const response = await axios
        .get(url, {
          headers: {
            Authorization: `${type} ${token}`,
          },
        })
        .then(response => {
          const billDate = moment
            .utc(response.data[0]['dueDate'])
            .subtract(1, 'months')
            .format('YYYY-MM-DD');
          return billDate;
        });
      return response;
    } catch (error) {
      console.log(error);
    }
  }
}
